export function MascaraTelefone(value) {
    if (!value) return "";

    // Remove tudo que não é número
    value = value.replace(/\D/g, "");

    // Limita a 11 dígitos (DDD + número)
    if (value.length > 11) value = value.slice(0, 11);

    // Formatação para telefone fixo (10 dígitos)
    if (value.length === 10) {
        // (XX) XXXX-XXXX
        return value.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
    }

    // Formatação para celular (11 dígitos)
    if (value.length === 11) {
        // (XX) X XXXX-XXXX
        return value.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})$/, "($1) $2 $3-$4");
    }

    // Formatação parcial (enquanto o usuário digita)
    if (value.length <= 2) return `(${value}`;
    if (value.length <= 6) return value.replace(/^(\d{2})(\d+)/, "($1) $2");
    if (value.length <= 10) return value.replace(/^(\d{2})(\d{4})(\d+)/, "($1) $2-$3");
    return value.replace(/^(\d{2})(\d{1})(\d{4})(\d+)/, "($1) $2 $3-$4");
}
